export default class Tooltips {
  constructor(node, index) {
    this.node = node
    this.index = index

    this.openButton = this.node.querySelector('.tooltip-button')
    this.closeButton = this.node.querySelector('.tooltip-close')
    this.box = this.node.querySelector('.tooltip-box')

    this.openTooltip = this.openTooltip.bind(this)
    this.closeTooltip = this.closeTooltip.bind(this)

    this.init()
  }

  init() {
    console.debug('  -> Tooltips init')
    this.addListeners()
  }

  // addListeners() {
  //   this.openButton.addEventListener('click', this.openTooltip)
  //   this.openButton.addEventListener('keydown', (e) => {
  //     console.log('Enter pressed!')
  //     if( e.key === 'Enter' ){
  //       this.openTooltip
  //     }
  //   })
  //   this.closeButton.addEventListener('click', this.closeTooltip)
  //   this.openButton.addEventListener('keydown', (e) => {
  //     if( e.key === 'Enter' ){
  //       this.closeTooltip
  //     }
  //   })
  // }

  addListeners() {
    // Listener for openButton
    this.openButton.addEventListener('click', (e) => {
      this.openTooltip()
    })
    this.openButton.addEventListener('keydown', (e) => {
      if( e.key === 'Enter' ) {
        this.openTooltip()
      }
    })

    // Listener for closeButton
    this.closeButton.addEventListener('click', (e) => {
        this.closeTooltip()
    })
    this.closeButton.addEventListener('keydown', (e) => {
      if( e.key === 'Enter' ) {
        this.closeTooltip()
      }
    })
  }

  openTooltip() {
    this.closeAllTooltips()
    this.node.classList.add('open')

    const tooltipButton = this.node.querySelector('.tooltip-button')
    const tooltipClose = this.node.querySelector('.tooltip-close')
    if( tooltipButton ){
      tooltipButton.setAttribute('tabindex', '-1')
      setTimeout(() => {
        tooltipClose.focus()
      }, 50)
    }
  }

  closeTooltip() {
    this.node.classList.remove('open')

    const tooltipButton = this.node.querySelector('.tooltip-button')
    if( tooltipButton ){
      tooltipButton.setAttribute('tabindex', '0')
    }
  }

  closeAllTooltips() {
    const allElements = document.querySelectorAll('.section-tooltip')
    allElements.forEach((element) => {
      element.classList.remove('open')

      const tooltipButton = element.querySelector('.tooltip-button')
      if( tooltipButton ){
        tooltipButton.setAttribute('tabindex', '0')
      }
    })  
  }

  destroy() {
    console.debug('  -> Tooltips destroy', this.node)

    this.openButton.removeEventListener('click', this.openTooltip)
    this.closeButton.removeEventListener('click', this.closeTooltip)
  }

  static destroyAll() {
    console.debug('  -> Tooltips destroy all')
    Tooltips.items.forEach((elem) => {
      elem.destroy()
    })
  }

  static init() {
    console.debug('== Tooltips components ==')
    Tooltips.items = Array.from(document.querySelectorAll('.tooltip')).map(
      (node, index) => new Tooltips(node, index)
    )
  }
}
